import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
const ActionButtonContainer = ({ onClick, isLoading, isValid }) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      caption: getLabel("checkout.serviceStore.actionButton")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      isLoading,
      onClick,
      caption: labels.caption,
      variant: "outline",
      className: "service-store__button",
      "data-t": "service-store-action-button",
      "aria-invalid": !isValid
    }
  );
};
export {
  ActionButtonContainer
};
//# sourceMappingURL=ActionButtonContainer.js.map
